
import api from "../../../../../api/api"





const save = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/cdnote-voucher-item",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const cdNoteItemServices = {
    save,
}
export default cdNoteItemServices;